import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsFourArticlesHighlightBlockPageSectionHolder = styled.div<{
  $isInPost?: boolean;
}>`
  padding-left: ${gutterWidth / 4}px;
  padding-right: ${gutterWidth / 4}px;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    justify-content: flex-start;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding-left: ${gutterWidth / 2}px;
    padding-right: ${gutterWidth / 2}px;

    ${(props) => `width: ${props.$isInPost ? '33%' : '25%'};`};
    &:nth-child(4) {
      ${(props) => props.$isInPost && `display: none;`};
    }
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    width: 50%;
  }

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    width: 100%;

    &:not(:first-child) {
      margin-top: ${(gutterWidth * 3) / 4}px;
    }
  }

  @media all and (min-width: ${cssBreakpoints.smDown}) and (max-width: ${cssBreakpoints.mdDown}) {
    &:not(:nth-child(1), :nth-child(2)) {
      margin-top: ${gutterWidth}px;
    }
  }

  a {
    position: relative;
    display: block;
    max-width: 240px;
  }
`;

export const CmsFourArticlesHighlightBlockPageSection_Box_1 = styled.div`
  margin-bottom: ${gutterWidth / 4}px;
  position: relative;
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-bottom: ${gutterWidth / 2}px;
  }
`;
